import React from 'react';
import classNames from 'classnames';
import styles from './blast-schedule-editor.module.scss';
import { SmsSegmentEvaluation } from './smsSegmentCounter';

const SEGMENT_COLORS = ['green', 'yellow', 'orange', 'red'] as const;

export const SmsSegmentMeter: React.FC<{ evaluation: SmsSegmentEvaluation }> = ({ evaluation }) => {
    return (
        <div className={styles['sms-segment-meter']}>
            <div
                className={styles['sms-segment-meter-bar']}
                role="progressbar"
                aria-label="SMS segment length"
                aria-valuemin={0}
                aria-valuemax={4}
                aria-valuenow={Math.min(evaluation.parts, 4)}
                aria-valuetext={
                    evaluation.overLimit ? 'Over the 3-segment limit' : `Segment ${evaluation.parts} of 3`
                }
            >
                {evaluation.segmentFills.map((fill, index) => {
                    const color = SEGMENT_COLORS[index];
                    return (
                        <div key={color} className={styles['sms-segment-meter-segment']}>
                            <div
                                className={classNames(
                                    styles['sms-segment-meter-segment-fill'],
                                    styles[`sms-segment-meter-segment-fill-${color}`]
                                )}
                                style={{ width: `${Math.round(fill * 1000) / 10}%` }}
                            />
                        </div>
                    );
                })}
            </div>
            {evaluation.warnings.map(warning => (
                <div key={warning} className={styles['sms-segment-meter-warning']}>
                    {warning}
                </div>
            ))}
            {evaluation.messages.map(message => (
                <div key={message} className={styles['sms-segment-meter-error']}>
                    {message}
                </div>
            ))}
        </div>
    );
};
